const routes = [{
  path: '/package', // 套餐
  children: [{
    path: '/coupon/:packageIds',
    load: () => import(/* webpackChunkName: 'packagecoupon' */ './package/coupon'),
  }],
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes/course/index.js